import React, {useState} from 'react';
import {
  IconBankNotes,
  IconCreditCard,
  // IconCheck,
  // IconChevronLeft,
  // IconChevronRight,
  // IconSpinner,
} from "../../../../../components/icons";
import {useFormik} from "formik";
import {Frais} from "../../../../../components/models";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";
import {createFrais, updateFrais} from "../../../../../components/requests";
import {useAuth} from "../../../../contexts/AuthContext";

interface FraisProps {
  remorqueHT?: string | number;
  remorqueTTC?: string | number;
  gardiennageHT?: string | number;
  gardiennageTTC?: string | number;
  autreFraisHT?: string | number;
  autreFraisTTC?: string | number;
  fraisTotauxHT?: string | number;
  fraisTotauxTTC?: string | number;
  fraisChargeHT?: string | number;
  fraisChargeTTC?: string | number;
  fraisDuesHT?: string | number;
  fraisDuesTTC?: string | number;
  joursGardiennage?: string | number;
  jourGardiennageCharge?: string | number;
  dateRappel1?: string;
  dateRappel2?: string;
  dateRemboursement1?: string;
  dateRemboursement2?: string;
  montantRemboursement1?: string | number;
  montantRemboursement2?: string | number;
}

type FraisErrors = Partial<Record<keyof FraisProps, string>>;

const validate = (values: FraisProps): FraisErrors => {
  const errors: FraisErrors = {};

  if (!values.remorqueHT && values.remorqueHT !== 0) {
    errors.remorqueHT = 'Ce champ est requis';
  } else if (values.remorqueHT < 1) {
    errors.remorqueHT = 'Veuillez saisir une valeur supérieur à 0';
  }
  if (!values.remorqueTTC && values.remorqueTTC !== 0) {
    errors.remorqueTTC = 'Ce champ est requis';
  } else if (values.remorqueTTC < 1) {
    errors.remorqueTTC = 'Veuillez saisir une valeur supérieur à 0';
  }
  if (!values.gardiennageHT && values.gardiennageHT !== 0) {
    errors.gardiennageHT = 'Ce champ est requis';
  } else if (values.gardiennageHT < 1) {
    errors.gardiennageHT = 'Veuillez saisir une valeur supérieur à 0';
  }
  if (!values.gardiennageTTC && values.gardiennageTTC !== 0) {
    errors.gardiennageTTC = 'Ce champ est requis';
  } else if (values.gardiennageTTC < 1) {
    errors.gardiennageTTC = 'Veuillez saisir une valeur supérieur à 0';
  }

  return errors;
};

const FraisForm = (
  {
    frais = null,
    setFrais = null,
    // setIsActive = null
  }: {
    frais?: Frais | null,
    setFrais?: any | null,
    // setIsActive?: any | null,
  }) => {
  const {id} = useParams();

  const {canView} = useAuth();

  const [fraisId, setFraisId] = useState<number | null>(null);
  // const [isValideLoading, setIsValideLoading] = useState<boolean>(false);
  // const [isBrouillonLoading, setIsBrouillonLoading] = useState<boolean>(false);
  // const [isBrouillon, setIsBrouillon] = useState<boolean | null>(null);

  const formik = useFormik({
    initialValues: {
      remorqueHT: frais ? frais.remorqueHT : '',
      remorqueTTC: frais ? frais.remorqueTTC : '',
      gardiennageHT: frais ? frais.gardiennageHT : '',
      gardiennageTTC: frais ? frais.gardiennageTTC : '',
      autreFraisHT: frais ? frais.autreFraisHT : '',
      autreFraisTTC: frais ? frais.autreFraisTTC : '',
      fraisTotauxHT: frais ? frais.fraisTotauxHT : '',
      fraisTotauxTTC: frais ? frais.fraisTotauxTTC : '',
      fraisChargeHT: frais ? frais.fraisChargeHT : '',
      fraisChargeTTC: frais ? frais.fraisChargeTTC : '',
      fraisDuesHT: frais ? frais.fraisDuesHT : '',
      fraisDuesTTC: frais ? frais.fraisDuesTTC : '',
      joursGardiennage: frais ? frais.joursGardiennage : '',
      jourGardiennageCharge: frais ? frais.jourGardiennageCharge : '',
      dateRappel1: frais ? frais.dateRappel1?.split('T')[0] : '',
      dateRappel2: frais ? frais.dateRappel2?.split('T')[0] : '',
      dateRemboursement1: frais ? frais.dateRemboursement1?.split('T')[0] : '',
      dateRemboursement2: frais ? frais.dateRemboursement2?.split('T')[0] : '',
      montantRemboursement1: frais ? frais.montantRemboursement1 : '',
      montantRemboursement2: frais ? frais.montantRemboursement2 : '',
    },
    enableReinitialize: true,
    validate,
    onSubmit: (values: FraisProps) => {
      // if (isBrouillon) setIsBrouillonLoading(true)
      // else setIsValideLoading(true);

      let payload = {
        remorqueHT: values.remorqueHT,
        remorqueTTC: values.remorqueTTC,
        gardiennageHT: values.gardiennageHT,
        gardiennageTTC: values.gardiennageTTC,
        autreFraisHT: values.autreFraisHT,
        autreFraisTTC: values.autreFraisTTC,
        fraisTotauxHT: values.fraisTotauxHT,
        fraisTotauxTTC: values.fraisTotauxTTC,
        fraisChargeHT: values.fraisChargeHT,
        fraisChargeTTC: values.fraisChargeTTC,
        fraisDuesHT: values.fraisDuesHT,
        fraisDuesTTC: values.fraisDuesTTC,
        joursGardiennage: values.joursGardiennage,
        jourGardiennageCharge: values.jourGardiennageCharge,
        dateRappel1: values.dateRappel1,
        dateRappel2: values.dateRappel2,
        dateRemboursement1: values.dateRemboursement1,
        dateRemboursement2: values.dateRemboursement2,
        montantRemboursement1: values.montantRemboursement1,
        montantRemboursement2: values.montantRemboursement2,
        // brouillon: isBrouillon,
        ...((!frais) ? {dossier: `api/dossiers/${id}`} : {})
      };

      const method = (!frais) ? createFrais(payload) : updateFrais((frais.id) ? frais.id : fraisId, payload)
      method
        .then((response) => {
          if ((response.status === 200 || response.status === 201) && response.data !== undefined) {
            setFrais({
              ...((!frais) ? {} : {id: frais.id}),
              remorqueHT: payload.remorqueHT,
              remorqueTTC: payload.remorqueTTC,
              gardiennageHT: payload.gardiennageHT,
              gardiennageTTC: payload.gardiennageTTC,
              autreFraisHT: payload.autreFraisHT,
              autreFraisTTC: payload.autreFraisTTC,
              fraisTotauxHT: payload.fraisTotauxHT,
              fraisTotauxTTC: payload.fraisTotauxTTC,
              fraisChargeHT: payload.fraisChargeHT,
              fraisChargeTTC: payload.fraisChargeTTC,
              fraisDuesHT: payload.fraisDuesHT,
              fraisDuesTTC: payload.fraisDuesTTC,
              joursGardiennage: payload.joursGardiennage,
              jourGardiennageCharge: payload.jourGardiennageCharge,
              dateRappel1: payload.dateRappel1,
              dateRappel2: payload.dateRappel2,
              dateRemboursement1: payload.dateRemboursement1,
              dateRemboursement2: payload.dateRemboursement2,
              montantRemboursement1: payload.montantRemboursement1,
              montantRemboursement2: payload.montantRemboursement2,
              // brouillon: payload.brouillon,
            })
            if (!frais) setFraisId(response.data['@id'].split('/').pop())
            toast.success(`Frais ${(!frais) ? 'créé' : 'modifié'}`);
          }
        })
        .catch((error) => console.error(error))
        .finally(() => {
          // if (isBrouillon) setIsBrouillonLoading(false)
          // else setIsValideLoading(false);
        })
    },
  });

  return (
    <>
      {/*<form onSubmit={formik.handleSubmit}>*/}
      <div className="p-4 animate-in fade-in duration-300">
        <div className="grid grid-cols-2 gap-4">
          {canView('Frais') && (
            <div className="section-card">
              <div className="section-header">
                <div className="section-icon bg-blue-100 text-blue-600">
                  <IconBankNotes/>
                </div>
                <span className="section-title">Frais</span>
              </div>
              <div className="section-body grid grid-cols-2 gap-3">
                <div className="w-full max-w-md">
                  <label className="form-label">
                    Remorquage (HT)
                  </label>
                  <div className="flex rounded-md w-full">
                    <input
                      type="number"
                      name="remorqueHT"
                      min={0}
                      value={formik.values.remorqueHT}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      readOnly
                      disabled
                      placeholder="ht"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.remorqueHT && (
                    <p className="mt-1 text-xs text-red-600">{formik.errors.remorqueHT}</p>
                  )}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Remorquage (TTC)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="remorqueTTC"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ttc"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.remorqueTTC}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.remorqueTTC ? <div className="text-xs text-red-600">
                    {formik.errors.remorqueTTC}
                  </div> : null}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Gardiennage (HT)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="gardiennageHT"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ht"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.gardiennageHT}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.gardiennageHT ? <div className="text-xs text-red-600">
                    {formik.errors.gardiennageHT}
                  </div> : null}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Gardiennage (TTC)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="gardiennageTTC"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ttc"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.gardiennageTTC}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.gardiennageTTC ? <div className="text-xs text-red-600">
                    {formik.errors.gardiennageTTC}
                  </div> : null}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Autre frais (HT)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="autreFraisHT"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ht"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.autreFraisHT}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.autreFraisHT ? <div className="text-xs text-red-600">
                    {formik.errors.autreFraisHT}
                  </div> : null}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Autre frais (TTC)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="autreFraisTTC"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ttc"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.autreFraisTTC}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.autreFraisTTC ? <div className="text-xs text-red-600">
                    {formik.errors.autreFraisTTC}
                  </div> : null}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Frais totaux (HT)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="fraisTotauxHT"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ht"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.fraisTotauxHT}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.fraisTotauxHT ? <div className="text-xs text-red-600">
                    {formik.errors.fraisTotauxHT}
                  </div> : null}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Frais totaux (TTC)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="fraisTotauxTTC"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ttc"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.fraisTotauxTTC}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.fraisTotauxTTC ? <div className="text-xs text-red-600">
                    {formik.errors.fraisTotauxTTC}
                  </div> : null}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Frais à notre charge (HT)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="fraisChargeHT"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ht"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.fraisChargeHT}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.fraisChargeHT ? <div className="text-xs text-red-600">
                    {formik.errors.fraisChargeHT}
                  </div> : null}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Frais à notre charge (TTC)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="fraisChargeTTC"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ttc"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.fraisChargeTTC}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.fraisChargeTTC ? <div className="text-xs text-red-600">
                    {formik.errors.fraisChargeTTC}
                  </div> : null}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Frais dues (HT)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="fraisDuesHT"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ht"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.fraisDuesHT}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.fraisDuesHT ? <div className="text-xs text-red-600">
                    {formik.errors.fraisDuesHT}
                  </div> : null}
                </div>
                <div className="w-full max-w-md">
                  <label className="form-label">Frais dues (TTC)</label>
                  <div className="flex rounded-md w-full">
                    <input
                      name="fraisDuesTTC"
                      type="number"
                      className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                      min={0}
                      placeholder="ttc"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.fraisDuesTTC}
                      disabled={true}
                      readOnly={true}
                    />
                    <span className="inline-flex items-center px-3 input-group-text">
                      €
                    </span>
                  </div>
                  {formik.errors.fraisDuesTTC ? <div className="text-xs text-red-600">
                    {formik.errors.fraisDuesTTC}
                  </div> : null}
                </div>
                <div>
                  <label className="form-label">jours de gardiennage</label>
                  <input
                    name="joursGardiennage"
                    type="number"
                    className="form-input hover:cursor-not-allowed"
                    min={0}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.joursGardiennage}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.errors.joursGardiennage ? <div className="text-xs text-red-600">
                    {formik.errors.joursGardiennage}
                  </div> : null}
                </div>
                <div>
                  <label className="form-label">Dont à charge</label>
                  <input
                    name="jourGardiennageCharge"
                    type="number"
                    className="form-input hover:cursor-not-allowed"
                    min={0}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.jourGardiennageCharge}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.errors.jourGardiennageCharge ? <div className="text-xs text-red-600">
                    {formik.errors.jourGardiennageCharge}
                  </div> : null}
                </div>
                {/*<div className="col-span-2">*/}
                {/*  <div className="gap-2 flex items-center justify-center h-48">*/}
                {/*    <span*/}
                {/*      className="px-4 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 hover:cursor-pointer"*/}
                {/*    >*/}
                {/*      Calculer Frais*/}
                {/*    </span>*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
            </div>
          )}
          {canView('Paiement & Suivi') && (
            <div className="section-card">
              <div className="section-header">
                <div className="section-icon bg-purple-100 text-purple-600">
                  <IconCreditCard/>
                </div>
                <span className="section-title">Paiement & Suivi</span>
              </div>
              <div className="section-body grid grid-cols-2 gap-3">
                {formik.values.dateRemboursement1 && (
                  <div className="col-span-2">
                    <label className="form-label">Date de remboursement 1</label>
                    <input
                      name="dateRemboursement1"
                      type={formik.values.dateRemboursement1 ? "date" : "text"}
                      className="form-input hover:cursor-not-allowed"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.dateRemboursement1}
                      disabled={true}
                      readOnly={true}
                    />
                    {formik.errors.dateRemboursement1 ? <div className="text-xs text-red-600">
                      {formik.errors.dateRemboursement1}
                    </div> : null}
                  </div>
                )}
                {formik.values.montantRemboursement1 !== null && formik.values.montantRemboursement1 !== 0 && (
                  <div className="col-span-2">
                    <label className="form-label">Montant de remboursement 1</label>
                    <div className="flex rounded-md w-full">
                      <input
                        name="montantRemboursement1"
                        type="number"
                        className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                        min={0}
                        placeholder="ttc"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.montantRemboursement1}
                        disabled={true}
                        readOnly={true}
                      />
                      <span className="inline-flex items-center px-3 input-group-text">
                        €
                      </span>
                    </div>
                    {formik.errors.montantRemboursement1 ? <div className="text-xs text-red-600">
                      {formik.errors.montantRemboursement1}
                    </div> : null}
                  </div>
                )}
                {formik.values.dateRemboursement2 && (
                  <div className="col-span-2">
                    <label className="form-label">Date de remboursement 2</label>
                    <input
                      name="dateRemboursement2"
                      type={formik.values.dateRemboursement2 ? "date" : "text"}
                      className="form-input hover:cursor-not-allowed"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.dateRemboursement2}
                      disabled={true}
                      readOnly={true}
                    />
                    {formik.errors.dateRemboursement2 ? <div className="text-xs text-red-600">
                      {formik.errors.dateRemboursement2}
                    </div> : null}
                  </div>
                )}
                {formik.values.montantRemboursement2 !== null && formik.values.montantRemboursement2 !== 0 && (
                  <div className="col-span-2">
                    <label className="form-label">Montant de remboursement 2</label>
                    <div className="flex rounded-md w-full">
                      <input
                        name="montantRemboursement2"
                        type="number"
                        className="flex-1 block w-full form-input-group hover:cursor-not-allowed"
                        min={0}
                        placeholder="ttc"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.montantRemboursement2}
                        disabled={true}
                        readOnly={true}
                      />
                      <span className="inline-flex items-center px-3 input-group-text">
                        €
                      </span>
                    </div>
                    {formik.errors.montantRemboursement2 ? <div className="text-xs text-red-600">
                      {formik.errors.montantRemboursement2}
                    </div> : null}
                  </div>
                )}
                {formik.values.dateRappel1 && (
                  <div className="col-span-2">
                    <label className="form-label">Date de rappel 1</label>
                    <input
                      name="dateRappel1"
                      type={formik.values.dateRappel1 ? "date" : "text"}
                      className="form-input hover:cursor-not-allowed"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.dateRappel1}
                      disabled={true}
                      readOnly={true}
                    />
                    {formik.errors.dateRappel1 ? <div className="text-xs text-red-600">
                      {formik.errors.dateRappel1}
                    </div> : null}
                  </div>
                )}
                {formik.values.dateRappel2 && (
                  <div className="col-span-2">
                    <label className="form-label">Date de rappel 2</label>
                    <input
                      name="dateRappel2"
                      type={formik.values.dateRappel2 ? "date" : "text"}
                      className="form-input hover:cursor-not-allowed"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.dateRappel2}
                      disabled={true}
                      readOnly={true}
                    />
                    {formik.errors.dateRappel2 ? <div className="text-xs text-red-600">
                      {formik.errors.dateRappel2}
                    </div> : null}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      {/*<div className="fixed bottom-0 left-60 right-0 bg-white border-t border-gray-200 py-3 px-4 z-30">*/}
      {/*  <div className="max-w-[1600px] mx-auto flex items-center justify-between">*/}
      {/*    <div className="flex items-center gap-3">*/}
      {/*      <span*/}
      {/*        onClick={() => setIsActive('enlevement')}*/}
      {/*        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        <IconChevronLeft className="w-4 h-4"/>*/}
      {/*        Précédent*/}
      {/*      </span>*/}
      {/*      <span*/}
      {/*        onClick={() => null}*/}
      {/*        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        Suivant*/}
      {/*        <IconChevronRight className="w-4 h-4"/>*/}
      {/*      </span>*/}
      {/*    </div>*/}
      {/*    <div className="flex items-center gap-2">*/}
      {/*      <span*/}
      {/*        onClick={() => formik.resetForm()}*/}
      {/*        className="px-3 py-1.5 border border-gray-300 rounded-lg text-gray-700 text-sm font-medium hover:bg-gray-50 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        Annuler*/}
      {/*      </span>*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        onClick={() => setIsBrouillon(true)}*/}
      {/*        className="px-3 py-1.5 bg-gray-800 text-white rounded-lg text-sm font-medium hover:bg-gray-900 flex items-center gap-1.5"*/}
      {/*      >*/}
      {/*        {(isBrouillonLoading) && <IconSpinner className="animate-spin w-4 h-4"/>}*/}
      {/*        {(isBrouillonLoading) ? 'Enregistrement' : 'Brouillon'}*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        onClick={() => setIsBrouillon(false)}*/}
      {/*        className="px-4 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 flex items-center gap-1.5"*/}
      {/*      >*/}
      {/*        {(isValideLoading) ? <IconSpinner className="animate-spin w-4 h-4"/> : <IconCheck className="w-4 h-4"/>}*/}
      {/*        {(isValideLoading) ? 'Enregistrement' : 'Valider'}*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*</form>*/}
    </>
  );
}

export default FraisForm;